module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Light TH.f7a27fb0.woff";